import { useNavigate } from 'react-router-dom';
import { useTheme } from '../hooks/useTheme';
import { RegistroClienteForm } from '../components/forms/RegistroClienteForm';
import logo from '../assets/Logo.png';

export const RegistroPage = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const handleSuccess = (email: string) => {
    // Redirigir a pantalla de éxito después de registro
    navigate(`/registro-exitoso?email=${encodeURIComponent(email)}`);
  };

  const handleCancel = () => {
    navigate('/');
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      theme === 'dark' 
        ? 'bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900' 
        : 'bg-gradient-to-br from-gray-50 via-white to-gray-100'
    }`}>
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-emerald-400/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-400/10 rounded-full blur-3xl"></div>
      </div>

      {/* Content */}
      <div className="relative min-h-screen flex flex-col items-center justify-center p-4">
        <img src={logo} alt="ConfiFarma" className="h-16 mb-6 drop-shadow-lg" />
        <div className="w-full max-w-lg">
          <RegistroClienteForm 
            onSuccess={handleSuccess}
            onCancel={handleCancel}
            className="w-full"
          />
          
          {/* Link al login */}
          <div className="text-center mt-6">
            <p className={`${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
              ¿Ya tienes cuenta?{' '}
              <button
                onClick={() => navigate('/login')}
                className="text-emerald-600 hover:text-emerald-700 font-medium hover:underline"
              >
                Inicia sesión aquí
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};